import { Link, type To } from 'react-router-dom';
import cn from 'classnames';

export type SegmentedLink = {
  key: string;
  to: To;
  label: string;
  active: boolean;
};

// Белая пилюля с сегментами, активный залит тёмным (макет telecom): табы
// раздела ниже lg (ScreenTabBar, variant 'segmented') и фильтр статуса тикетов.
// Сегменты — ссылки, а не кнопки: выбранный живёт в адресе, поэтому переживает
// перезагрузку и кнопку «назад». Какой активен, решает вызывающий: табы раздела
// сравнивают путь, фильтр — параметр запроса.
export const SegmentedLinks = ({
  items,
  className,
}: {
  items: SegmentedLink[];
  className?: string;
}) => (
  <nav className={cn('flex w-max max-w-full gap-0.5 rounded-full bg-surface-card p-1', className)}>
    {items.map((item) => (
      <Link
        key={item.key}
        to={item.to}
        aria-current={item.active ? 'page' : undefined}
        className={cn(
          'whitespace-nowrap rounded-full px-4 py-2 text-[13px] font-bold leading-4 transition-colors',
          item.active
            ? 'bg-content-primary text-content-inverse'
            : 'text-content-secondary hover:text-content-primary',
        )}
      >
        {item.label}
      </Link>
    ))}
  </nav>
);
